
export const blogPosts = [
  {
    id: 1,
    slug: 'como-ia-esta-revolucionando-atendimento-cliente',
    title: 'Como a IA Está Revolucionando o Atendimento ao Cliente em 2025',
    excerpt: 'Descubra como empresas estão usando inteligência artificial para transformar a experiência do cliente e aumentar a satisfação em até 300%.',
    content: '',
    category: 'Atendimento',
    categoryColor: 'bg-accent-green',
    image: 'https://public.readdy.ai/ai/img_res/97a438632dcc924554867ea78b298033.jpg',
    author: 'Ana Silva',
    authorAvatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20headshot%20portrait%20corporate%20style%20neutral%20background%20confident%20smile%20business%20attire&width=100&height=100&seq=author1&orientation=squarish',
    date: '15 Jan 2025',
    readTime: '5 min',
    featured: true,
  },
  {
    id: 2,
    slug: 'automacao-processos-guia-completo',
    title: 'Automação de Processos: Guia Completo para Empresas',
    excerpt: 'Um guia passo a passo para implementar automação inteligente na sua empresa e reduzir custos operacionais em até 60%.',
    content: '',
    category: 'Automação',
    categoryColor: 'bg-amber-500',
    image: 'https://readdy.ai/api/search-image?query=robotic%20process%20automation%20concept%20with%20digital%20workflows%20and%20connected%20systems%20abstract%20technology%20visualization%20dark%20background%20with%20glowing%20teal%20and%20orange%20circuit%20lines&width=800&height=500&seq=blog2&orientation=landscape',
    author: 'Carlos Mendes',
    authorAvatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20headshot%20portrait%20corporate%20style%20neutral%20background%20friendly%20expression%20business%20casual&width=100&height=100&seq=author2&orientation=squarish',
    date: '12 Jan 2025',
    readTime: '8 min',
    featured: true,
  },
  {
    id: 3,
    slug: 'chatbots-inteligentes-vs-tradicionais',
    title: 'Chatbots Inteligentes vs Tradicionais: Qual a Diferença?',
    excerpt: 'Entenda as diferenças fundamentais entre chatbots baseados em regras e chatbots com IA generativa.',
    content: '',
    category: 'IA Conversacional',
    categoryColor: 'bg-teal-500',
    image: 'https://readdy.ai/api/search-image?query=comparison%20between%20old%20and%20new%20chatbot%20technology%20split%20screen%20visualization%20robotic%20vs%20human%20like%20AI%20assistant%20modern%20tech%20aesthetic%20dark%20gradient%20background&width=800&height=500&seq=blog3&orientation=landscape',
    author: 'Marina Costa',
    authorAvatar: 'https://readdy.ai/api/search-image?query=professional%20young%20brazilian%20woman%20headshot%20portrait%20tech%20industry%20style%20neutral%20background%20modern%20look&width=100&height=100&seq=author3&orientation=squarish',
    date: '10 Jan 2025',
    readTime: '6 min',
    featured: false,
  },
  {
    id: 4,
    slug: 'roi-implementacao-ia-empresas',
    title: 'ROI da Implementação de IA: Números Reais de Empresas Brasileiras',
    excerpt: 'Análise detalhada do retorno sobre investimento em projetos de IA com dados de mais de 50 empresas.',
    content: '',
    category: 'Negócios',
    categoryColor: 'bg-emerald-500',
    image: 'https://readdy.ai/api/search-image?query=business%20analytics%20dashboard%20showing%20ROI%20metrics%20and%20growth%20charts%20modern%20data%20visualization%20with%20upward%20trending%20graphs%20dark%20theme%20with%20green%20accent%20colors&width=800&height=500&seq=blog4&orientation=landscape',
    author: 'Roberto Lima',
    authorAvatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20businessman%20headshot%20portrait%20executive%20style%20neutral%20background%20confident%20mature%20man&width=100&height=100&seq=author4&orientation=squarish',
    date: '8 Jan 2025',
    readTime: '10 min',
    featured: true,
  },
  {
    id: 5,
    slug: 'tendencias-ia-2025',
    title: '7 Tendências de IA que Vão Dominar 2025',
    excerpt: 'As principais tendências em inteligência artificial que toda empresa precisa conhecer para se manter competitiva.',
    content: '',
    category: 'Tendências',
    categoryColor: 'bg-rose-500',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20technology%20trends%20visualization%20with%20neural%20networks%20and%20digital%20innovation%20symbols%20abstract%20tech%20art%20dark%20background%20with%20vibrant%20teal%20and%20pink%20accents&width=800&height=500&seq=blog5&orientation=landscape',
    author: 'Juliana Santos',
    authorAvatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20tech%20executive%20headshot%20portrait%20modern%20style%20neutral%20background%20innovative%20look&width=100&height=100&seq=author5&orientation=squarish',
    date: '5 Jan 2025',
    readTime: '7 min',
    featured: false,
  },
  {
    id: 6,
    slug: 'integracao-whatsapp-ia',
    title: 'Como Integrar IA ao WhatsApp Business da Sua Empresa',
    excerpt: 'Tutorial completo para configurar um assistente de IA no WhatsApp e automatizar o atendimento 24/7.',
    content: '',
    category: 'Tutorial',
    categoryColor: 'bg-green-500',
    image: 'https://readdy.ai/api/search-image?query=WhatsApp%20business%20integration%20with%20AI%20chatbot%20smartphone%20interface%20showing%20automated%20conversation%20modern%20tech%20visualization%20clean%20white%20and%20green%20color%20scheme&width=800&height=500&seq=blog6&orientation=landscape',
    author: 'Pedro Oliveira',
    authorAvatar: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20developer%20headshot%20portrait%20casual%20tech%20style%20neutral%20background%20friendly%20approachable&width=100&height=100&seq=author6&orientation=squarish',
    date: '3 Jan 2025',
    readTime: '12 min',
    featured: false,
  },
];

export const blogCategories = [
  { name: 'Todos', count: 6 },
  { name: 'Atendimento', count: 1 },
  { name: 'Automação', count: 1 },
  { name: 'IA Conversacional', count: 1 },
  { name: 'Negócios', count: 1 },
  { name: 'Tendências', count: 1 },
  { name: 'Tutorial', count: 1 },
];
